import { z } from 'zod'

import { OptionalPhoneCountryCodeSchema } from './phone'

export const ContactTypeSchema = z.string()

export const ContactTypeEnumSchema = z.enum([
  'primary',
  'secondary',
  'general',
  'transport',
  'accounts',
])

export const GetContactSchema = z.object({
  email: z.string().nullable(),
  hx: z.string().nullable(),
  id: z.number(),
  last_name: z.string().nullish(),
  member_id: z.number().nullable(),
  method: z.string().nullable(),
  name: z.string().nullable(),
  nickname: z.string().nullable(),
  notes: z.string().nullable(),
  phone: z.string().nullable(),
  phone_country: z.string().length(2).nullish(),
  phone_formatted: z.string().nullish(),
  style: z.string().nullable(),
  timocom_id: z.string().nullable(),
  trans_id: z.string().nullable(),
  type: ContactTypeSchema.nullable(),
  whatsapp: z.string().nullable(),
})

const PostContactBaseSchema = z.object({
  email: z.string().email().nullable().optional(),
  hx: z.string().nullable().optional(),
  last_name: z.string().nullable().optional(),
  method: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  nickname: z.string().nullable().optional(),
  notes: z.string().nullable().optional(),
  phone: z.string().trim().nullable().optional(),
  phone_country: OptionalPhoneCountryCodeSchema.nullish().optional(),
  position_id: z.number().nullable().optional(),
  style: z.string().nullable().optional(),
  timocom_id: z.string().nullable().optional(),
  trans_id: z.string().nullable().optional(),
  type: ContactTypeEnumSchema,
  whatsapp: z.string().nullable().optional(),
})

export const PostContactSchema = PostContactBaseSchema

export const PatchContactSchema = PostContactBaseSchema.partial()

export type Contact = z.infer<typeof GetContactSchema>
export type ContactType = z.infer<typeof ContactTypeSchema>
export type ContactTypeEnum = z.infer<typeof ContactTypeEnumSchema>
export type PatchContact = z.infer<typeof PatchContactSchema>
export type PostContact = z.infer<typeof PostContactSchema>
